import type React from 'react'

import { cn } from '../lib/utils'

type TextProps = React.HTMLAttributes<HTMLParagraphElement> & {
    children?: React.ReactNode
    testId?: string
}

export const Title = ({ className, ...props }: TextProps) => {
    return (
        <h1
            data-testid={props.testId ?? 'title'}
            className={cn(
                'text-center font-bold text-lp-dark1 text-2xl',
                className,
            )}
            {...props}
        >
            {props.children}
        </h1>
    )
}
